/** Build-time demo only; never activate from a URL or production session. */
export const DEMO_MODE =
  import.meta.env.VITE_APP_ENV !== "production" &&
  import.meta.env.VITE_DEMO_MODE === "1";
export const COACH_MOCK =
  DEMO_MODE ||
  (import.meta.env.VITE_APP_ENV !== "production" &&
    import.meta.env.VITE_COACH_API_MOCK === "1");
